module.exports = __webpack_public_path__ + "static/media/Google.3b741d6e.svg";